import type { RealEstateCase } from "./types";
import { isListingPreparationCase } from "./listingPreparation.ts";

export const isClosedLostCase = (caseItem: RealEstateCase) => Boolean(caseItem.closedLostAt);

export const caseLeadState = (caseItem: RealEstateCase): "Aktívny" | "Čakajúci" | "Vyradený" => {
  if (caseItem.leadState) return caseItem.leadState;
  if (caseItem.stage === "Čakajúci") return "Čakajúci";
  if (caseItem.stage === "Vyradený" || isClosedLostCase(caseItem) || ["Odmietnutý", "Uzavretý", "Stratené"].includes(caseItem.stage)) {
    return "Vyradený";
  }
  return "Aktívny";
};

export const isWaitingCase = (caseItem: RealEstateCase) => caseLeadState(caseItem) === "Čakajúci";
export const isExcludedCase = (caseItem: RealEstateCase) => caseLeadState(caseItem) === "Vyradený";
export const isActiveBusinessCase = (caseItem: RealEstateCase) => caseLeadState(caseItem) === "Aktívny";
export const isArchivedCase = (caseItem: RealEstateCase) => isExcludedCase(caseItem) || caseItem.stage === "Predané";
export const isLiveCase = (caseItem: RealEstateCase) => !isArchivedCase(caseItem) && (isActiveBusinessCase(caseItem) || isWaitingCase(caseItem));

export const caseStateCounts = (cases: RealEstateCase[]) => ({
  active: cases.filter((caseItem) => isLiveCase(caseItem) && caseLeadState(caseItem) === "Aktívny").length,
  waiting: cases.filter((caseItem) => caseLeadState(caseItem) === "Čakajúci").length,
  excluded: cases.filter((caseItem) => caseLeadState(caseItem) === "Vyradený").length
});

export const isAgendaExcludedCase = (caseItem: RealEstateCase) =>
  isExcludedCase(caseItem) || ["Predané", "Uzavretý"].includes(caseItem.stage);

export const canAddMissingNextStep = (caseItem: RealEstateCase) =>
  !caseItem.followUp && !isListingPreparationCase(caseItem) && !isAgendaExcludedCase(caseItem);

export const closeLostCase = (caseItem: RealEstateCase, reason: string, closedAt: string): RealEstateCase => ({
  ...caseItem,
  stage: "Odmietnutý",
  status: "Odmietnutý",
  lostReason: reason,
  closedLostAt: closedAt,
  followUp: undefined,
  nextStep: "Bez ďalšieho kroku",
  updatedAt: closedAt
});

export const restoreClosedLostCase = (caseItem: RealEstateCase, restoredAt: string): RealEstateCase => ({
  ...caseItem,
  leadState: "Aktívny",
  stage: "Aktívne",
  status: "Aktívne",
  closedLostAt: undefined,
  excludedAt: undefined,
  exclusionReason: undefined,
  followUp: undefined,
  nextStep: "Chýba ďalší krok",
  updatedAt: restoredAt
});
